import { Mark } from 'slate'
import { UNDERLINE_MARK } from './markTypes'

export default function UnderlineMark() {
  return Mark.create({
    type: UNDERLINE_MARK
  })
}
